(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('ORULO_INTEGRATION_STATUS', {
            NEW: 'NEW',
            READY_TO_UPDATE: 'READY_TO_UPDATE',
            FAILED: 'FAILED',
            CANCELLED: 'CANCELLED',
            INVALID_TOKEN: 'INVALID_TOKEN',
            IN_PROGRESS: 'IN_PROGRESS',
            ERROR: {
                INVALID_TOKEN: 'oruloInvalidToken',
                REQUIRED_CREDENTIALS: 'requiredCredentials',
                IN_PROGRESS_JOB: 'oruloInProcessingToJob',
                RATE_LIMIT_EXCEEDED: 'oruloRateLimitExceeded'
            }
        });

})();
